import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    Paper,
    Typography,
} from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import React, { useContext, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { cateringDashboardWidgets } from './dashboardSettingsConstants';
import axios from 'axios';
import Config from '../../../../config/Config';
import { RestauInfoContext } from '../../../../home/RestauInfoContext';
import useCateringDashboard from '../../CateringDashboard/useCateringDashboard';
//import PropTypes from 'prop-types';

function DashboardSettings() {
    const { restauHook } = useContext(RestauInfoContext);
    const { dashboardWidgets, loading } = useCateringDashboard();

    // Initialize state with widgets that have displayByDefault: true
    const [selectedWidgetsToDisplay, setSelectedWidgetsToDisplay] = useState(
        {}
    );

    // State to maintain the ordered list of widgets
    const [orderedWidgets, setOrderedWidgets] = useState([]);

    const [saveInProgress, setSaveInProgress] = useState(false);

    useEffect(() => {
        // Initialize selectedWidgetsToDisplay based on dashboardWidgets
        const widgetsToSelect = {};

        if (dashboardWidgets && dashboardWidgets.length > 0) {
            // Use dashboardWidgets from backend if available
            dashboardWidgets.forEach((widget) => {
                widgetsToSelect[widget.value] = true;
            });

            // Set ordered widgets based on backend order if available
            // Otherwise use the default order from constants
            setOrderedWidgets([...cateringDashboardWidgets]);
        } else {
            // Otherwise use default widgets
            cateringDashboardWidgets.forEach((widget) => {
                widgetsToSelect[widget.value] = false;
            });

            // Initialize ordered widgets with default order
            setOrderedWidgets([...cateringDashboardWidgets]);
        }

        setSelectedWidgetsToDisplay(widgetsToSelect);
    }, [dashboardWidgets]);

    // Handle checkbox change
    const handleCheckboxChange = (widgetValue) => {
        setSelectedWidgetsToDisplay((prev) => ({
            ...prev,
            [widgetValue]: !prev[widgetValue],
        }));
    };

    // Handle select all
    const handleSelectAll = () => {
        const selectedWidgets = {};
        cateringDashboardWidgets.forEach((widget) => {
            selectedWidgets[widget.value] = true;
        });
        setSelectedWidgetsToDisplay(selectedWidgets);
    };

    // Handle clear all
    const handleClearAll = () => {
        const clearedWidgets = {};
        cateringDashboardWidgets.forEach((widget) => {
            clearedWidgets[widget.value] = false;
        });
        setSelectedWidgetsToDisplay(clearedWidgets);
    };

    // Handle drag end for react-beautiful-dnd
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(orderedWidgets);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setOrderedWidgets(items);
    };

    // Handle save
    const handleSave = async () => {
        // Get the selected widgets in their current order
        const selectedWidgets = orderedWidgets
            .filter((widget) => selectedWidgetsToDisplay[widget.value])
            .map((widget) => widget.value);

        if (selectedWidgets.length === 0) {
            alert('Atleast one of the widget should be selected..');
            return;
        }

        console.log('Selected widgets to save (in order):', selectedWidgets);

        // TODO: Implement actual save logic here
        // This could be calling a Firebase function, updating Firestore, etc.
        // For now, just logging the selected widgets
        setSaveInProgress(true);
        const token = await window.customerApp.auth().currentUser.getIdToken();
        var config = {
            headers: {
                token: token,
                'Content-Type': 'application/json',
            },
        };

        //debugger;
        let payload = {
            restauId: restauHook.restauId,
            updatedDashboardSettings: {
                selectedWidgets,
                widgetOrder: orderedWidgets.map((w) => w.value), // Save the complete order
            },
        };
        //function to fetch the Phone Settings from databasse
        let response = await axios.post(
            Config.saveCateringDashboardSettings,
            payload,
            config
        );
        if (response && response.status === 200) {
            alert('Catering dashboard settings saved succesfully !');
        } else {
            alert('Failed while saving Catering dashboard settings..');
        }
        setSaveInProgress(false);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <FormControl sx={{ m: 2 }} component="fieldset" variant="standard">
                <FormLabel
                    component="legend"
                    sx={{
                        fontSize: '1.25rem',
                        fontWeight: 600,
                        mb: 2,
                        color: 'text.primary',
                    }}
                >
                    Widgets to display in Dashboard
                    {loading && (
                        <CircularProgress
                            size={24}
                            style={{ color: 'black', marginLeft: '5px' }}
                        />
                    )}
                </FormLabel>
                <FormGroup>
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable droppableId="dashboard-widgets">
                            {(provided, snapshot) => (
                                <Box
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    sx={{
                                        width: '100%',
                                        maxWidth: '600px',
                                        backgroundColor: snapshot.isDraggingOver
                                            ? 'action.hover'
                                            : 'transparent',
                                        borderRadius: 1,
                                        transition: 'background-color 0.2s',
                                        p: snapshot.isDraggingOver ? 1 : 0,
                                    }}
                                >
                                    {!loading &&
                                        orderedWidgets.length > 0 &&
                                        orderedWidgets.map((widget, index) => (
                                            <Draggable
                                                key={widget.value}
                                                draggableId={widget.value}
                                                index={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <Paper
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        elevation={
                                                            snapshot.isDragging
                                                                ? 3
                                                                : 1
                                                        }
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            p: 0.5,
                                                            mb: 0.5,
                                                            minHeight: '60px',
                                                            backgroundColor:
                                                                snapshot.isDragging
                                                                    ? 'action.selected'
                                                                    : 'background.paper',
                                                            transform:
                                                                snapshot.isDragging
                                                                    ? 'rotate(1deg) scale(1.02)'
                                                                    : 'none',
                                                            transition:
                                                                'all 0.2s ease',
                                                            '&:hover': {
                                                                backgroundColor:
                                                                    'action.hover',
                                                                transform:
                                                                    'translateY(-2px)',
                                                                boxShadow: 2,
                                                            },
                                                            ...provided
                                                                .draggableProps
                                                                .style,
                                                        }}
                                                    >
                                                        <Box
                                                            {...provided.dragHandleProps}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                cursor: 'grab',
                                                                '&:active': {
                                                                    cursor: 'grabbing',
                                                                },
                                                            }}
                                                        >
                                                            <DragIndicatorIcon
                                                                sx={{
                                                                    color: 'action.active',
                                                                    mr: 1.5,
                                                                    ml: 1,
                                                                    fontSize:
                                                                        '1.3rem',
                                                                }}
                                                            />
                                                        </Box>
                                                        <FormControlLabel
                                                            sx={{
                                                                flex: 1,
                                                                m: 0,
                                                                overflow:
                                                                    'hidden',
                                                            }}
                                                            control={
                                                                <Checkbox
                                                                    checked={
                                                                        selectedWidgetsToDisplay[
                                                                            widget
                                                                                .value
                                                                        ] ||
                                                                        false
                                                                    }
                                                                    onChange={() =>
                                                                        handleCheckboxChange(
                                                                            widget.value
                                                                        )
                                                                    }
                                                                    name={
                                                                        widget.value
                                                                    }
                                                                />
                                                            }
                                                            label={
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontSize:
                                                                            '0.95rem',
                                                                        lineHeight: 1.5,
                                                                    }}
                                                                >
                                                                    {
                                                                        widget.label
                                                                    }
                                                                </Typography>
                                                            }
                                                        />
                                                    </Paper>
                                                )}
                                            </Draggable>
                                        ))}
                                    {provided.placeholder}
                                </Box>
                            )}
                        </Droppable>
                    </DragDropContext>
                </FormGroup>
                <FormHelperText sx={{ mt: 2, fontSize: '0.9rem' }}>
                    Select widgets to display in dashboard. Drag and drop to
                    reorder them.
                </FormHelperText>

                {/* Action Buttons */}
                <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleSelectAll}
                    >
                        Select All
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleClearAll}
                    >
                        Clear All
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={handleSave}
                        disabled={saveInProgress}
                    >
                        Save
                        {saveInProgress && (
                            <CircularProgress
                                size={24}
                                style={{ color: 'black', marginLeft: '5px' }}
                            />
                        )}
                    </Button>
                </Box>
            </FormControl>
        </Box>
    );
}

DashboardSettings.propTypes = {};

export default DashboardSettings;
